export { FrontPage } from "./front-page.component";
